const imageCache = new Map<string, Promise<HTMLImageElement>>();

export function loadPaletteImage(url: string): Promise<HTMLImageElement> {
  const cached = imageCache.get(url);
  if (cached) return cached;

  const promise = new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => {
      imageCache.delete(url);
      reject(new Error(`Palette picker could not load image asset: ${url}`));
    };
    image.decoding = "async";
    image.src = url;
  });
  imageCache.set(url, promise);
  return promise;
}

export function preloadPaletteImages(urls: readonly string[]): void {
  for (const url of urls) void loadPaletteImage(url).catch(() => undefined);
}
